module.exports = __webpack_public_path__ + "img/v2.f8a78dd9.png";